import React, { useCallback, useState } from 'react'
import { WemoloButton, WemoloCheckCircleIcon } from '../../../components/Wemolo'

const CopyIconSvg: React.FC = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect x="8" y="8" width="12" height="12" rx="2" stroke="currentColor" strokeWidth="2" />
        <path
            d="M16 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h3"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
        />
    </svg>
)

export type CopyButtonProps = {
    value: string
    ariaLabel: string
}

const COPIED_FEEDBACK_MS = 1500

export const CopyButton: React.FC<CopyButtonProps> = ({ value, ariaLabel }) => {
    const [copied, setCopied] = useState(false)

    const handleClick = useCallback(async () => {
        try {
            await navigator.clipboard.writeText(value)
            setCopied(true)
            setTimeout(() => setCopied(false), COPIED_FEEDBACK_MS)
        } catch {
            setCopied(false)
        }
    }, [value])

    return (
        <WemoloButton
            view="ghost"
            size="small"
            icon={copied ? <WemoloCheckCircleIcon /> : <CopyIconSvg />}
            aria-label={ariaLabel}
            onClick={handleClick}
        />
    )
}
